import React from 'react';
import { WARMUPS_SONG_ID } from '../../../../services/songNotesModel';
import SongPicker from './SongPicker';
import './SongTabs.css';

/**
 * Song tabs — plain pill buttons, NOT wa-tab-group (zero in-app usage; the
 * design's active/inactive pill is simpler as bare buttons). 40px min-height,
 * radius 999. Active: --cyv-primary fill + --cyv-on-primary, music icon.
 * Inactive: 1.5px --cyv-line on --surface-card. A dashed 40px "+" opens
 * Add a song.
 *
 * The outstanding-work count (open notes, not a progress fraction) rides the
 * tab as a small badge. Warm-ups is built-in and carries no remove control.
 *
 * Since 2026-10-02 the row holds only the songs THIS lesson is using
 * (`songs` arrives filtered, notes/todaySongs.js), and the whole repertoire
 * (`allSongs`) is behind the Songs picker at the end of the row. A pill's ×
 * tucks the song back into the picker; it no longer takes it off the board.
 */
const SongTabs = ({ songs, allSongs = null, today = null, currentSongId, onSelect, onAdd, onRemove = null, onOpen = null }) => {
	return (
		<div className="ld-tabs" role="tablist" aria-label="Songs" data-guide="lesson-song-tabs">
			{songs.map((song) => {
				const active = song.id === currentSongId;
				const openCount = (song.notes || []).filter((n) => n.status !== 'landed').length;
				return (
					<span key={song.id} className={`ld-tab-wrap${active ? ' is-active' : ''}`}>
						<button
							type="button"
							role="tab"
							aria-selected={active}
							className="ld-tab"
							onClick={() => onSelect(song.id)}>
							<i className="fa-sharp fa-solid fa-music" aria-hidden="true" />
							<span className="ld-tab__name">{song.name}</span>
							{openCount > 0 && (
								<span className="ld-tab__count" title={`${openCount} still open`}>
									{openCount}
								</span>
							)}
						</button>
						{onRemove && song.id !== WARMUPS_SONG_ID && (
							<button
								type="button"
								className="ld-tab__remove"
								aria-label={`Put ${song.name} back in the Songs list`}
								onClick={(e) => {
									e.stopPropagation();
									onRemove(song.id);
								}}>
								<i className="fa-sharp fa-solid fa-xmark" aria-hidden="true" />
							</button>
						)}
					</span>
				);
			})}

			{allSongs && (
				<SongPicker songs={allSongs} today={today || new Set()} currentSongId={currentSongId} onOpen={onOpen || onSelect} onAdd={onAdd} />
			)}

{/* With the picker, Add a song lives at the bottom of its list. */}
			{!allSongs && (
			<button
				type="button"
				className="ld-tab-add"
				data-guide="lesson-add-song"
				aria-label="Add a song"
				onClick={onAdd}>
				<i className="fa-sharp fa-solid fa-plus" aria-hidden="true" />
			</button>
			)}
		</div>
	);
};

export default SongTabs;
